import { useMutation, useQueryClient } from '@tanstack/react-query';
import mcpUsuariosService from '../services/mcpUsuariosService';
import { mcpUsuariosKeys } from '../queryKeys';

const useCrearMcpUsuario = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ email, notas }) => mcpUsuariosService.crear({ headquarter, email, notas }),
    onSuccess: () => qc.invalidateQueries({ queryKey: mcpUsuariosKeys.all }),
  });
};

export default useCrearMcpUsuario;
